import React from 'react';

const AboutHeroSection = () => {
  return (
    <section style={{
      position: 'relative',
      minHeight: '100vh',
      width: '100%',
      backgroundColor: '#242423',
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      alignItems: 'center',
      padding: '0 1rem'
    }}>
      {/* Background Image Layer - Very Subtle */}
      <div style={{
        position: 'absolute',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundImage: 'url(/assets/images/About-1770328122194.png)',
        backgroundSize: 'cover',
        backgroundPosition: 'center top',
        backgroundRepeat: 'no-repeat',
        opacity: 0.12,
        zIndex: 0
      }} />

      {/* Gradient Fade Overlay - Aggressive Fade */}
      <div style={{
        position: 'absolute',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        background: 'linear-gradient(to bottom, transparent 0%, rgba(36, 36, 35, 0.4) 30%, rgba(36, 36, 35, 0.8) 60%, #242423 85%)',
        zIndex: 1
      }} />

      {/* Existing Content - DO NOT MODIFY */}
      <div style={{
        position: 'relative',
        zIndex: 2
      }} className="max-w-4xl mx-auto text-center px-4 md:px-6 lg:px-8">
        {/* Main Headline */}
        <h1 className="text-2xl font-bold text-foreground mb-6 md:mb-8 leading-tight">
          Our Mission
        </h1>

        {/* Mission Statement */}
        <p className="text-base md:text-lg lg:text-xl text-muted-foreground max-w-3xl mx-auto leading-relaxed">
          Our goal is to become the standard infrastructure that next-gen Physical AI applications deploy on.
        </p>
      </div>
    </section>
  );
};

export default AboutHeroSection;